export default __webpack_public_path__ + "static/media/slider.5ecd7112.gif";